import { useQuery } from "@tanstack/react-query";
import { api } from "../../../lib/api";

export function KycUploadedPreview({ fileKey }: { fileKey: string }) {
  const previewQ = useQuery({
    queryKey: ["flexxi-kyc-file-preview", fileKey],
    queryFn: () => api<{ url: string }>(`/flexxi/kyc/file-preview?key=${encodeURIComponent(fileKey)}`),
    staleTime: 5 * 60_000,
  });

  const url = previewQ.data?.url;

  if (previewQ.isLoading) {
    return (
      <div className="rounded-xl border border-white/10 bg-white/5 px-3 py-6 text-center text-[11px] text-white/45">
        Loading preview…
      </div>
    );
  }

  if (!url) {
    return (
      <p className="rounded-lg border border-emerald-500/30 bg-emerald-500/10 px-3 py-2 text-[11px] text-emerald-200">
        Document received securely
      </p>
    );
  }

  return (
    <img src={url} alt="" className="max-h-40 w-full rounded-xl border border-white/10 object-contain bg-black/20" />
  );
}
